export default __webpack_public_path__ + "static/media/hero-a.4a338137.jpg";